import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { safeStorage } from '@/lib/storage'
import { bootTheme } from '@/theme'
import { App } from '@/App'
import { BrandProvider } from '@/brand/BrandProvider'
import '@/index.css'
// The app frame, after the utilities. The token layer and the Atlas component
// layer are linked from index.html ahead of the bundle (scripts/sync-design.sh),
// so the order stays tokens -> components -> utilities -> layout.
import '@/styles/app.css'

const root = document.getElementById('root')
if (!root) {
  // Not defensive noise: the SPA-rewrite CloudFront function serves index.html
  // for every extensionless path, so a missing #root means the wrong index.html
  // was published — a deploy fault, not a runtime one, and it should say so.
  throw new Error('#root is missing from index.html — check what was published to the web bucket')
}

// Before the first paint, so no screen renders in one theme and flips to the
// stored one once a toggle mounts (see `bootTheme`).
bootTheme(safeStorage(), window.matchMedia('(prefers-color-scheme: dark)'))

createRoot(root).render(
  <StrictMode>
    {/* Outermost, above the router and every provider `App` mounts: the
        brand is a property of the host, not of the session or the route, and
        nothing may draw before it is known (see `BrandProvider`). */}
    <BrandProvider>
      <App />
    </BrandProvider>
  </StrictMode>,
)
